import React from "react";
import { Container } from "react-bootstrap";
import "./Payment.css";

const Payment = () => {
  return (
    <Container className="payment">
      <h1>Payment System Coming Soon...!!</h1>
    </Container>
  );
};

export default Payment;
